import axios from "axios";

// Tags job create/update requests with where the change came from, for the job status history log.
// Explicit X-Status-Source headers on a request take precedence.
const PAGE_SOURCES = [
  [/^\/production/, "production_board_drag"],
  [/^\/retail/, "retail_builder_save"],
  [/^\/(quote|quantity-break)/, "quote_builder_save"],
];

const isJobWrite = (config) =>
  ["put", "post"].includes((config.method || "").toLowerCase()) && /\/api\/jobs(\/save|\/[^/]+)$/.test(config.url || "");

axios.interceptors.request.use((config) => {
  if (isJobWrite(config)) {
    const headers = config.headers || {};
    const hasSource = typeof headers.get === "function" ? headers.get("X-Status-Source") : headers["X-Status-Source"];
    if (!hasSource) {
      const match = PAGE_SOURCES.find(([re]) => re.test(window.location.pathname));
      const isRetail = config.data && typeof config.data === "object" && config.data.client_type === "Retail";
      if (match) headers["X-Status-Source"] = isRetail && match[1] === "quote_builder_save" ? "retail_builder_save" : match[1];
      config.headers = headers;
    }
  }
  return config;
});
